import React, { useState, useCallback, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';

function WebHookInfo({ handleClose, notification, action, selectedWebhook, refreshList }) {
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const { userId } = JSON.parse(sessionStorage.user).user;
  const formModel = {
    url: '',
    headers: null,
    eventType: '',
    isActive: true,
    level: null,
    levelId: orgId,
    organizationId: orgId,
    createdBy: userId,
    recipients: [],
    status: action === 'create' ? 'Active' : '',
  };

  const [formData, setFormData] = useState(formModel);
  const [header, setHeaders] = useState();
  const [receipient, setReceipient] = useState([]);
  const [zones, setZones] = useState([]);
  const [eventTypes, setEventTypes] = useState([]);
  const [scope, setScope] = useState([]);

  const [{ isLoading, isError, data }, postData] = useApi();
  const [devices, getDevice] = useApi();
  const [warehouse, getWarehouse] = useApi();
  const [project, getProject] = useApi();
  const [state, getDataForUpdate] = useApi();
  const [state2, updateData] = useApi();
  const [eventsRes, getEvents] = useApi();

  const key = useRef(null);
  const value = useRef(null);
  const receipientRef = useRef(null);

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  useEffect(() => {
    getDevice(`/organization/${orgId}/devices?deviceType=BLE_GW`, 'GET');
    getWarehouse(`/organization/${orgId}/warehouses`, 'GET');
    getProject(`/organization/${orgId}/projects`, 'GET');
    getEvents('/events', 'GET');
  }, []);

  useEffect(() => {
    if (!eventsRes.isLoading && !eventsRes.isError && eventsRes.data) {
      if (eventsRes.data.events) setEventTypes(eventsRes.data.events);
    }
  }, [eventsRes]);

  useEffect(() => {
    if (!warehouse.isLoading && !warehouse.isError && warehouse.data) {
      let x = [];
      warehouse.data.warehouses.forEach((z) => {
        x = [...x, ...z.Zones];
      });

      setZones(x);
    }
  }, [warehouse]);

  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/webhook/${selectedWebhook}`, 'GET');
    }
  }, [action]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.status === 'InActive') {
      formData.isActive = false;
    } else {
      formData.isActive = true;
    }

    if (receipientRef.current.value) {
      receipient.push(receipientRef.current.value);
    }

    formData.recipients = receipient.length > 0 ? receipient : null;

    const body = {
      ...formData,
      headers: header,
    };
    // console.log(body);
    if (action === 'create') postData('/webhook', 'POST', body);
    else updateData(`/webhook/${selectedWebhook}`, 'PATCH', body);
  };

  // create response
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      refreshList();
      notification('success', 'Webhook Created Successfully');
      handleClose();
    }

    if (isError) {
      notification('error', data);
    }
  }, [isLoading, isError, data]);

  // getUser for update response
  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      if (state.data.webhook.isActive) {
        formData.status = 'Active';
      } else {
        formData.status = 'InActive';
      }
      setFormData(state.data.webhook);
      setScope(eventTypes.filter((x) => x.name === state.data.webhook.eventType)[0].scope);

      if (state.data.webhook.recipients) setReceipient(state.data.webhook.recipients);
    }

    if (state.isError) {
      notification('error', state.data);
    }
  }, [state, eventTypes]);

  // update response
  useEffect(() => {
    if (state2.data) {
      notification('update', 'Webhook Updated Successfully');
      refreshList();
      handleClose();
    }

    if (state2.isError) {
      if (state2.data) {
        notification('error', state2.data);
      } else {
        notification('error', 'App is facing network related issues.');
      }
    }
  }, [state2]);

  const handleAddAttributes = () => {
    const x = { ...header };
    const k = key.current.value;
    const v = value.current.value;

    x[k] = v;
    setHeaders(x);
  };

  useEffect(() => {
    key.current.value = '';
    value.current.value = '';
  }, [header]);

  const deleteAttribute = (item) => {
    const attr = { ...header };
    delete attr[item[0]];

    setHeaders(attr);
  };

  // const eventTypes = [
  //   'Select Event',
  //   'BLE_TAG_SEEN_FIRST',
  //   'BLE_TAG_IN_GATEWAY',
  //   'BLE_TAG_OUT_GATEWAY',
  //   'BLE_TAG_GONE_INACTIVE',
  //   'CATM1_TAG_DATA_AVAILABLE',
  //   'RECENT_REPORTING_BLE_GATEWAY',
  //   'FAST_RECENT_REPORTING_BLE_GATEWAY',
  //   'LOGGER_UPDATED_BY_GATEWAY',
  //   'LOGGER_DATA_STORED_IN_S3',
  //   'RTLS_UDP_DATA_RECEIVED',
  // ];

  const handleAddReceipient = (e) => {
    e.preventDefault();
    const k = receipientRef.current.value;
    if (!ValidateEmail(k)) {
      notification('error', `Enter valid emailId`);
      receipientRef.current.value = '';
      return;
    }
    const x = receipient;
    setReceipient([...x, k]);
    receipientRef.current.value = '';
  };

  function ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    return false;
  }

  const deleteReceipient = (item) => {
    const filterReceipient = receipient.filter((x) => x !== item);

    setReceipient(filterReceipient);
  };

  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-2/4 pt-1 relative rounded-2xl mobile_toggle">
        <div className="flex justify-between items-center border-b px-6">
          <p className="font-bold text-sm text-textBlue1  py-4">{action === 'create' ? 'Create' : 'Edit'} a Webhook</p>

          <img src="assets/img/Close.svg" className=" h-3 cursor-pointer" alt="" onClick={handleClose} />
        </div>
        <form className="mt-6 mb-2 mx-10 grid grid-cols-2 gap-x-6" onSubmit={handleSubmit} autoComplete="off">
          <div className="mt-5 w-full relative">
            <input
              type="text"
              placeHolder="URL"
              value={formData.url}
              name="url"
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>

          <div className="mt-5 w-full relative">
            <div className="px-4 py-2 focus:outline-none inputLabelText">
              <select
                name="eventType"
                value={formData.eventType}
                autoComplete="off"
                className="border-none w-full focus:outline-none text-sm  text-parameter border "
                onChange={(e) => {
                  // handleInputChange(e);
                  setFormData({
                    ...formData,
                    eventType: e.target.value,
                    level: '',
                  });

                  setScope(eventTypes.filter((x) => x.name === e.target.value)[0].scope);
                }}
              >
                <option value="">Select Event</option>
                {eventTypes.map((item) => (
                  <option key={item.id}>{item.name}</option>
                ))}
              </select>
            </div>
            {/* <input
              name="eventType"
              type="text"
              placeHolder="EVENT"
              value={formData.eventType}
              list="event_type"
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            /> */}
            {/* <datalist id="event_type">
              {eventTypes.map((item, idx) => (
                <option key={idx}>{item}</option>
              ))}
            </datalist> */}
          </div>

          {scope.length > 0 && (
            <div className="mt-5 w-full relative">
              <div className="px-4 py-2 focus:outline-none inputLabelText">
                <select
                  name="level"
                  value={formData.level}
                  autoComplete="off"
                  className="border-none w-full focus:outline-none text-sm  text-parameter border "
                  onChange={handleInputChange}
                >
                  <option className="fy-4">Select Scope</option>
                  {scope.map((x) => (
                    <option key={x} value={x}>
                      {x}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {formData.level && formData.level !== 'ORGANIZATION' && (
            <div className="mt-5 w-full relative">
              <div className="px-4 py-2 focus:outline-none inputLabelText">
                {formData.level === 'ORGANIZATION' && (
                  <input
                    name="levelId"
                    type="text"
                    autoComplete="off"
                    className="bg-white"
                    onChange={handleInputChange}
                    disabled
                  />
                )}
                {formData.level === 'PROJECT' && (
                  <select
                    name="levelId"
                    value={formData.levelId}
                    autoComplete="off"
                    className="border-none w-full focus:outline-none text-sm  text-parameter border "
                    onChange={handleInputChange}
                  >
                    <option className="fy-4">Select Project</option>
                    {project.data &&
                      project.data.projects &&
                      project.data.projects.length > 0 &&
                      project.data.projects.map((x) => (
                        <option key={x.id} value={x.id} className="fy-4">
                          {x.projectName}
                        </option>
                      ))}
                  </select>
                )}
                {formData.level === 'DEVICE' && (
                  <select
                    name="levelId"
                    value={formData.levelId}
                    autoComplete="off"
                    className="border-none w-full focus:outline-none text-sm  text-parameter border "
                    onChange={handleInputChange}
                  >
                    <option className="fy-4">Select Device</option>
                    {devices.data &&
                      devices.data.devices.map((x) => (
                        <option key={x.id} value={x.id} className="fy-4">
                          {x.id}
                        </option>
                      ))}
                  </select>
                )}
                {formData.level === 'WAREHOUSE' && (
                  <select
                    name="levelId"
                    value={formData.levelId}
                    autoComplete="off"
                    className="border-none w-full focus:outline-none text-sm  text-parameter border "
                    onChange={handleInputChange}
                  >
                    <option className="fy-4">Select Warehouse</option>
                    {warehouse.data &&
                      warehouse.data.warehouses.map((x) => (
                        <option key={x.id} value={x.id} className="fy-4">
                          {x.name}
                        </option>
                      ))}
                  </select>
                )}

                {formData.level === 'ZONE' && (
                  <select
                    name="levelId"
                    value={formData.levelId}
                    autoComplete="off"
                    className="border-none w-full focus:outline-none text-sm  text-parameter border "
                    onChange={handleInputChange}
                  >
                    <option className="fy-4">Select Zone</option>
                    {zones.map((x) => (
                      <option key={x.id} value={x.id} className="fy-4">
                        {x.name}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            </div>
          )}

          <div className="mt-5 w-full relative">
            {/* <label htmlFor="isActive" className="block text-parameter w-1/3 text-sm">
              STATUS
            </label> */}
            <div className="inputLabelText px-4 py-2 focus:outline-none">
              <select
                name="status"
                value={formData.status}
                autoComplete="off"
                className="border-none w-full focus:outline-none text-sm  text-parameter border "
                onChange={handleInputChange}
              >
                <option key="true" value="Active" className="fy-4">
                  ACTIVE
                </option>
                <option key="false" value="InActive" className="fy-4">
                  INACTIVE
                </option>
              </select>
            </div>
          </div>

          <div className="mt-5 w-full relative">
            <input
              type="email"
              placeholder="Email of Receipient"
              ref={receipientRef}
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              // style={{ color: '#b3b3b3' }}
              // onChange={handleInputChange}
              onKeyDown={(e) => {
                // e.preventDefault()
                if (e.keyCode === 13) {
                  handleAddReceipient(e);
                }
              }}
            />
          </div>

          <div className="w-full flex mt-4 text-center col-span-2">
            {receipient &&
              receipient.map((item) => (
                <p
                  className="text-black text-xs py-1.5 px-4 text-center rounded-full border mr-4 shadow-md cursor-pointer"
                  onClick={() => deleteReceipient(item)}
                >
                  {item}
                </p>
              ))}
          </div>

          <p className="mt-5 w-full text-xs font-bold">Headers</p>
          <div></div>
          <div className="relative grid grid-cols-2 col-span-2 gap-x-6">
            <div className="mt-5 w-full">
              <input
                type="text"
                ref={key}
                placeHolder="Key"
                className="inputLabelText px-4 py-2 focus:outline-none"
                // onChange={handleInputChange}
              />
            </div>

            <div className="mt-5 w-full">
              <input
                type="text"
                ref={value}
                placeHolder="value"
                className="inputLabelText px-4 py-2 focus:outline-none"
                // onChange={handleInputChange}
              />
            </div>

            <img
              src="assets/img/Add.svg"
              className="absolute -right-8 h-6 top-7 cursor-pointer"
              alt=""
              onClick={handleAddAttributes}
            />
          </div>
          <div className="w-full flex">
            {header &&
              Object.entries(header).map((item) => (
                <p
                  className="text-black py-1 px-4 rounded-full border mx-2 cursor-pointer"
                  onClick={() => deleteAttribute(item)}
                >
                  {item.join(' - ')}
                </p>
              ))}
          </div>
          <div></div>

          <div className="w-full mt-5 mb-2 relative col-span-2">
            {state2.isLoading || isLoading ? (
              <div className="flex text-xs">
                <img src="assets/img/loader.svg" className="w-16 right-28 mx-auto" alt="" />
              </div>
            ) : (
              <div className="flex text-xs w-full ">
                <button
                  type="submit"
                  onClick={() => handleClose()}
                  className="rounded-3xl border focus:outline-none w-36 py-2 mr-3 cursor-pointer ml-auto"
                  // style={{ border: '1px solid #16406D' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rounded-3xl focus:outline-none w-36 py-2 text-white cursor-pointer "
                  style={{ background: '#16406D' }}
                >
                  Save
                </button>
              </div>
            )}
          </div>
          {/* <div className="flex w-1/2 items-center  my-3.5 relative">
            <label className="block text-parameter w-1/3 text-sm" />
            {state2.isLoading || isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto" alt="" />
            ) : (
              <input
                type="submit"
                className="rounded-lg focus:outline-none w-1/2 h-10 text-textBlue1 cursor-pointer "
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              />
            )}
          </div> */}
        </form>
      </div>
    </div>
  );
}

export default WebHookInfo;
